<template>
	<div>
		<ts-loading-banner :loading="loading">
			<form class="form-horizontal">
				<div class="row">
					<div class="col-md-12">
						<label class="required">{{ $t('teachingCalendar.teacher') }}</label>
						<div class="form-group ts-w-full">
							<a-select style="width: 100%" v-model="model.teacher_id" :options="teachers" showSearch :filterOption="(input, option) =>
								option.componentOptions.children[0].text
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
								" :maxTagCount="1" :maxTagTextLength="17">
							</a-select>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<label>{{ $t('teachingCalendar.staff') }}</label>
						<div class="form-group ts-w-full">
							<a-select style="width: 100%" v-model="model.staff_id" :options="staffs" showSearch :filterOption="(input, option) =>
								option.componentOptions.children[0].text
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
								" :maxTagCount="1" :maxTagTextLength="17">
							</a-select>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 text-right">
						<ts-button class="mr-2" @click="clearInput">{{
							$t('cancel')
						}}</ts-button>
						<ts-button color="primary" @click.prevent="onUpdate" :waiting="waiting">
							{{ $t("update") }}</ts-button>
					</div>
				</div>
			</form>
		</ts-loading-banner>
	</div>
</template>
  
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { isEmpty } from "lodash";
export default {
	name: 'edit',
	data() {
		return {
			loading: false,
			waiting: false,
			errors: new Errors(),
			teachers: [],
			staffs: [],
			model: {
				id: 0,
				teacher_id: undefined,
				staff_id: undefined
			}
		}
	},
	created() {
		this.setEditData()
		this.fetchTeacher()
		this.fetchStaff()
	},
	computed: {
		...mapState("teachingCalendar", ["edit_data"]),
	},
	methods: {
		async fetchTeacher() {
			await this.$store
				.dispatch('teachingCalendar/getTeacher')
				.then(response => {
					this.teachers = response.data.map(el => ({
						value: el.teacher_id,
						label: el.full_name_en
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		async fetchStaff() {
			await this.$store
				.dispatch('teachingCalendar/getStaff')
				.then(response => {
					this.staffs = response.data.map(el => ({
						value: el.emp_id,
						label: el.name_en
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onUpdate() {
			this.errors = new Errors()
			this.waiting = true
			this.$store
				.dispatch('teachingCalendar/update', this.model)
				.then(response => {
					this.$toasted.success(response.message)
					this.clearInput()
					this.$emit('fetchData')
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		setEditData() {
			if (!isEmpty(this.edit_data)) {
				this.model.id = this.edit_data.id
				this.model.teacher_id = this.edit_data.teacher_id
				this.model.staff_id = this.edit_data.staff_id
			}
		},
		clearInput() {
			this.$emit('close')
			this.errors = new Errors()
			this.model.teacher_id = undefined
			this.model.staff_id = undefined
		}
	}
}
</script>
  